module.exports = __webpack_public_path__ + "img/Engen-Website-Logo-768x682.a6d89ce2.png";